export function formatRadios(flag?: boolean | null): 'sim' | 'nao' | '' {
  if (flag === true) return 'sim'
  if (flag === false) return 'nao'
  return ''
}
